<template lang="pug">
.v-sticker.sticker(v-if="data" :class="[data.type ? 'sticker--' + data.type : '', data.size ? 'sticker--' + data.size : '']")
	.sticker__text {{data.text}}
</template>

<script>

export default {
	props: {
		data: {
			type: Object,
			default: null
		}
	}
}

</script>